export enum GoApplicationPurposeCodeEnum {
    NewLicense = 'A',
    NewLocation = 'L',
    NewFrequencies = 'F',
}
